import React from "react";
//#region types
import { TopTodoCardProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { EntityTopCardContent } from "components/common";
import { useTodoService } from "serviceHooks";
//#endregion

const TopTodoCard: React.FC<TopTodoCardProps> = (props) => {
  const todoService = useTodoService();
  return (
    <EntityTopCardContent
      {...props}
      title={props.overrideTitle ?? todoService.getTodoCardName(props.item.group, props.item.subType)}
      subTitle={todoService.getTodoCardSubTypeName(props.item.subType)}
      statusIndicatorDisplayType={todoService.getUIDisplayTypeByUrgency(
        props.item.urgencyChanged ? undefined : props.item.urgency
      )}
    />
  );
};
export default TopTodoCard;
